import Vue from 'vue'
import VueGtag from 'vue-gtag'
import store from '@store'

const merchantGa = window.globalData.merchant.ga
// const merchantGa = store.state.merchant.currentMerchant.ga

const IsJtails = store.state.merchant.alias === 'j-tails'
// const IsJtails = store.state.merchant.currentMerchant.alias === 'j-tails'

const includeGa = IsJtails
  ? [{ id: 'UA-1234567-2' }]
  : [
      /* { id: 'UA-1234567-2' },
     {
     id: 'UA-1234567-3',
     params: {
     send_page_view: false
     }
     } */
    ]

if (merchantGa) {
  Vue.use(VueGtag, {
    config: { id: merchantGa },
    includes: includeGa,
  })
}
